import { WithdrawalTypeEnumMap } from '@tassat/fred-definitions';

export const getWithdrawalTypeDisplayValue = (withdrawalTypeCode: string): string => {
    const entry = Object.values(WithdrawalTypeEnumMap).find((type) => type.value === withdrawalTypeCode);

    return entry?.displayValue ?? withdrawalTypeCode;
};
